<header class="header-area">
  <div class="header-nav">
    <div class="navigation row" id="can-sticky">
      <nav class="navbar navbar-expand-lg navbar-light mx-auto">
        <a class="navbar-brand col-lg-2 col-md-8 col-sm-4" routerLink="/">
          <!-- <div class="row">
            <div class="col-6 logo-img"></div>
          </div> -->
          <img src="assets/img/app/horizontal.png" class="logo" alt=""/>
        </a>
        <button
          class="navbar-toggler col-lg-1 col-md-2 col-sm-1"
          type="button"
          [ngClass]="navmethod ? '' : 'active'"
          (click)="isMenuCollapsed = !isMenuCollapsed; toggleNav()"
        >
          <span class="toggler-icon"></span>
          <span class="toggler-icon"></span>
          <span class="toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse sub-menu-bar col-lg-9 col-md-1 col-sm-1"
          [ngbCollapse]="isMenuCollapsed"
        >
          <ul class="navbar-nav ml-auto">
            <li class="nav-item menu-item">
              <a routerLink="/about">{{ "about" | translate }}</a>
            </li>
            <li class="nav-item menu-item">
              <a routerLink="/privacy">{{ "privacy" | translate }}</a>
            </li>
            <li class="nav-item menu-item">
              <a routerLink="/get-service-merchant">{{ "getService" | translate }}</a>
              <!-- <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a> -->
            </li>
            <li class="nav-item menu-item">
              <a routerLink="/news">{{ "news" | translate }}</a>
            </li>
          </ul>
        </div>
        <!-- <div class="bar-area navbar-toggler col-lg-1 col-md-2 col-sm-1">
          <ul>
            <li>
              <a href="#"><i class="fal fa-bars"></i></a>
            </li>
          </ul>
        </div> -->
      </nav>
    </div>
  </div>
</header>
